import { css as t, styled as n } from "styled-components";
import { e as r, t as i } from "./index-tc-On6zr.js";
import { c as o, a as l } from "./style-ImpGK6sv.js";
const p = {
  xs: r.spacer5,
  xl: r.spacer7
}, b = ({ $position: c, $spacing: e }) => t`
  ${Object.entries(e === "sm" ? { xs: r.spacer5 } : p).map(
  ([a, s]) => l(
    a,
    t`
          padding-top: ${c !== "bottom" && s};
          padding-bottom: ${c !== "top" && s};
        `
  )
)}
`, m = t`
  *,
  & {
    box-sizing: border-box;
  }
  ${b}

  ${i({
  dark: t`
      color: ${o.white};
      background-color: ${o.black};
    `,
  grey: t`
      color: ${o.black};
      background-color: ${o.grey};
    `,
  light: t`
      color: ${o.black};
      background-color: ${o.white};
    `
})}
`, k = n.section`
  ${m}
`;
export {
  k as S
};
